import { useContext } from 'react';
import { IModalContext } from '../models/modals';
import { ModalContext } from '../providers/ModalProvider';

export const useModalContext = (): IModalContext => useContext(ModalContext);
